export default __webpack_public_path__ + "static/media/carousel_3.ddd7f6d7.svg";